(() => {
  const initialize = async (root) => {
    await customElements.whenDefined('quick-nav');
    root.querySelectorAll('[data-ptt-bricks-navigation] quick-nav').forEach((nav) => {
      if (nav.dataset.pttBricksBound) return;
      nav.dataset.pttBricksBound = 'true';
      nav.addEventListener('change', (event) => {
        // Price-enabled finders use Enterprise's native collection and price loader.
        if (nav.dataset.showPrice === 'true') return;
        const select = event.target;
        if (!select.matches('custom-select')) return;
        event.stopImmediatePropagation();
        const level = Number(select.dataset.level);
        const selected = select.querySelector('[aria-selected="true"]');
        const value = event.detail?.selectedValue;
        nav.unparseCollectionInfo();
        if (!value || !selected?.dataset.url) {
          nav.constructor.resetSelect(select, false);
          nav.querySelectorAll('custom-select').forEach((child) => {
            if (Number(child.dataset.level) > level) nav.constructor.resetSelect(child, true);
          });
          nav.url = '';
          nav.updateSubmitButton('');
          return;
        }
        nav.url = selected.dataset.url;
        nav.updateSubmitButton(nav.url);
        if (level === 1 && nav.childSelect) {
          nav.constructor.prepareSelect(nav.childSelect, value);
          nav.constructor.resetSelect(nav.grandchildSelect, true);
        } else if (level === 2 && nav.grandchildSelect) {
          nav.constructor.prepareSelect(nav.grandchildSelect, value);
        }
      }, true);
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
